import { Action, handleActions } from 'redux-actions'

import { OS } from '@/domains/CommonDomain'
import { IRootState } from '@/modules'
import { createFetchAction } from '@/utils/actionUtils'
import { INativeInfo } from '@/utils/bridgeUtils/features/getNativeInfo'
import { apiFailureReducer } from '@/utils/reducerUtils'

interface IAppState {
  nativeInfo: INativeInfo
}

const initialState: IAppState = {
  nativeInfo: {
    applicationId: '',
    authToken: '',
    deviceId: '',
    language: '',
    osModel: '',
    osVersion: '',
    lineAccessToken: '',
  },
}

export const APP = 'CommonApp'

export const appAsync = createFetchAction(APP)

const reducer = {
  [appAsync.SUCCESS]: (state: IAppState, action: Action<any>) => {
    const { result } = action.payload

    return {
      ...state,
      nativeInfo: result,
    }
  },
  [appAsync.FAILURE]: apiFailureReducer,
}

export const appSelector = {
  nativeInfo: (state: IRootState) => state[APP].nativeInfo,
  isAOS: (state: IRootState) => {
    const info = appSelector.nativeInfo(state)
    const { osModel } = info

    return osModel === OS.AOS
  },
  isID: (state: IRootState) => {
    const info = appSelector.nativeInfo(state)
    const { language } = info

    return language
  },
}

export const appReducer = handleActions(reducer, initialState)
export const appSaga = []
